(function() { module.exports = window["novablocks"]["utils"]; }());